import React, { useEffect, useState } from 'react';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Input from 'b2b-ui-components-lib/lib/components/input';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import { getDefaultValue } from './formControl';
import { isFormValid } from '../../../../common/utils/validator';
import Select from 'b2b-ui-components-lib/lib/components/select';
import { addresses, ADDRESS_TYPE_ENUM, optionsForExistingAddress } from '../summary.constant';
import { fetchCityStateList } from '../../../../common/services/http.service';
import { prepareOptionsForDropDown } from '../../../services/summary.service';

const ShippingDetails = ({ order, updateParentForm, setFormStatus, isOrderConfirmation = false }) => {
  const [accordionMetadata, setAccordionMetadata] = useState({ isValidated: false });
  const [cityList, setCityList] = useState([]);
  const [form, setForm] = useState(getDefaultValue(order));

  const onChangeType = (selected) => {
    setForm({ ...getDefaultValue(order), selected });
  };
  const onExistingAddressChange = (address) => {
    setForm({ ...form, existingAddress: address });
  };
  const onPinCodeChange = (value) => setForm({ ...form, pinCode: { ...form.pinCode, value, touched: true, errors: form.pinCode.validator(value) } });
  const onaddressChange = (value) => setForm({ ...form, address: { ...form.address, value, touched: true, errors: form.address.validator(value) } });
  const onCityChange = (value) => setForm({ ...form, city: { ...form.city, value, touched: true } });

  const resetCityAddress = () => {
    setForm({ ...form, city: { ...form.city, value: '', touched: true }, address: { ...form.address, value: '', touched: true } });
  };

  const onFieldBlur = (formElement, keyName) => {
    const { value, validator, errors: existingError } = formElement;
    let errors = [];
    if (typeof validator === 'function') {
      errors = validator(value);
    }
    setForm({ ...form, [keyName]: { ...form[keyName], value, errors: errors.concat(existingError), touched: true } });
  };

  useEffect(() => {
    if (form.pinCode.errors.length === 0 && form.pinCode.value) {
      resetCityAddress();
      fetchCityStateList(form.pinCode.value).then(
        ({ data: { result } }) => {
          if (Array.isArray(result)) {
            setForm({
              ...form,
              pinCode: { ...form.pinCode, touched: true, errors: [] },
              city: { ...form.city, value: '', touched: true },
              address: { ...form.address, value: '', touched: true }
            });
            const cityList = prepareOptionsForDropDown(result, 'city');
            setCityList(cityList);
            if (cityList.length === 1) {
              onCityChange(cityList[0]);
            }
          }
        },
        (err) => {
          let errMsg = err && err.response && err.response.data && err.response.data.errorMsg;
          setCityList([]);
          setForm({
            ...form,
            pinCode: { ...form.pinCode, touched: true, errors: [errMsg ? errMsg : 'Please enter valid Pincode'] },
            city: { ...form.city, value: '', touched: true },
            address: { ...form.address, value: '', touched: true }
          });
          console.error(err);
        }
      );
    }
  }, [form.pinCode.value]);

  useEffect(() => {
    const keyToIgnore = form.selected.id === ADDRESS_TYPE_ENUM.EXISTINGADDRESS ? ['city', 'pinCode', 'address', 'isLcoCity'] : [ADDRESS_TYPE_ENUM.EXISTINGADDRESS, 'isLcoCity'];
    if (isFormValid(form, keyToIgnore)) {
      setAccordionMetadata({ isValidated: true });
      updateParentForm({ shippingDetails: form });
      setFormStatus({ shippingDetails: true });
    } else {
      setAccordionMetadata({ isValidated: false });
      updateParentForm({ shippingDetails: null });
      setFormStatus({ shippingDetails: false });
    }
  }, [form]);

  return (
    <React.Fragment>
      <Accordion
        title="Shipping Details"
        autoScrollOnExpand={false}
        isExpanded={true}
        isValidated={accordionMetadata.isValidated}
        isEditable={accordionMetadata.isEditable}
        onEditClick={() => setAccordionMetadata(({ isEditable }) => ({ ...accordionMetadata, isEditable: !isEditable }))}
      >
        <div className="accordion_body">
          <div>
            <div className="form_area">
              <RadioGroup options={addresses} value={form.selected} onChange={onChangeType} disabled={isOrderConfirmation} />
              {form.selected.id === ADDRESS_TYPE_ENUM.EXISTINGADDRESS ? (
                <div className="row">
                  <div className="flg-lg-12">
                    <Select
                      label="Select Existing Address"
                      value={form.existingAddress}
                      onChange={onExistingAddressChange}
                      options={optionsForExistingAddress}
                      placeholder="Select"
                      required
                      disabled={isOrderConfirmation}
                    />
                  </div>
                </div>
              ) : (
                <div className="row field_row">
                  <div className="flg-lg-6 flg-md-6">
                    <div className="row">
                      <div className="flg-lg-6 flg-md-6">
                        <Input
                          label="Pincode"
                          maxlength={6}
                          value={form.pinCode.value ? form.pinCode.value : ''}
                          isValidChange={(value) => /^(\s*|\d+)$/.test(value)}
                          onBlur={() => onFieldBlur(form.pinCode, 'pinCode')}
                          required
                          errors={form.pinCode.errors}
                          touched={form.pinCode.touched}
                          onChange={onPinCodeChange}
                          disabled={isOrderConfirmation}
                        />
                      </div>
                      <div className="flg-lg-6 flg-md-6">
                        <Select label="City" value={form.city.value} onChange={onCityChange} options={cityList} placeholder="City" required disabled={isOrderConfirmation} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="flg-lg-12">
                        <TextArea
                          label="Address"
                          disabled={isOrderConfirmation}
                          maxlength={250}
                          required
                          value={form.address.value}
                          onBlur={() => onFieldBlur(form.address, 'address')}
                          errors={form.address.errors}
                          touched={form.address.touched}
                          onChange={onaddressChange}
                        />
                      </div>
                      <div style={{ position: 'relative' }}>
                        <small id="helpId" className="help-text-counter">
                          {(form.address.value && form.address.value.length) || 0} /250
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Accordion>
    </React.Fragment>
  );
};

export default ShippingDetails;
